import * as React from "react";
import SignIn from "../../presentations/SignIn";

const SignInContainer = () => {
  return (
    <div>
      <SignIn />
    </div>
  );
};

export default SignInContainer;
